import mapboxgl from 'mapbox-gl';
import {startsWith} from 'lodash';

export default function resolveMapboxURL(url: string) {
    if (startsWith(url, 'mapbox://')) {
        const {accessToken} = mapboxgl;
        const [, , resource, user, ...restUrl] = url.split('/');
        const normalizedResource = (resource === 'style') ? 'styles' : resource;

        // eslint-disable-next-line max-len
        return `https://api.mapbox.com/${normalizedResource}/v1/${user}/${restUrl.join('/')}?access_token=${accessToken}`;

    } else {
        return url;
    }
}
